import {ValidationGroupType} from './types';
import {IValidation} from './validation.schema';

export type IValidationGroupType = {
	groupType: ValidationGroupType;
};

export type IValidationGroup = IValidationGroupType & {
	validations: IValidation[];
};

export function isValidationGroupType(value: unknown): value is IValidationGroupType {
	return (value as IValidationGroupType)?.groupType !== undefined;
}
